import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import _, { get } from 'lodash';
import { formFields } from './constant';
import { handleFieldError } from '../../../utils/form-validation';
import SelectNew from '../../FormElements/SelectNew';
import Input from '../../FormElements/Input';
import { withRouter } from 'react-router-dom';
import { postThirdPartyLoginPartnersAction } from '../../../actions';
import { thirdPartyAccountAction } from '../../../actions/thirdPartyAccount';

const DV360Account = ({ accounts, platform, isDisplayAccountName = false, children }) => {
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [options, setOptions] = useState({
        accountOptions: [],
        subAccountOptions: []
    });

    const [accountName, setAccountName] = useState('');
    const [accountCurrency, setAccountCurrency] = useState('');
    const [isAccountChanged, setIsAccountChanged] = useState(false);

    const dispatch = useDispatch();
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const partnersData = useSelector((state) => get(state, "app.thirdPartyLoginPartnersData.response", []));
    const cardsWidth = isDisplayAccountName ? `20%` : '25%';

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;
            const newForm = { ...form };
            newForm[e.target.name] = value;
            setForm(newForm);
            if (name === formFields.accountId.key)
                setIsAccountChanged(!isAccountChanged);
            if (name === formFields.subAccountId.key) {
                if (partnersData.length > 0) {
                    let selectedSubAccount = partnersData.find(item => item.customerId == value);
                    if (!selectedSubAccount) {
                        throw new Error(`No sub-account found with customer ID ${value}`);
                    }
                    let data = {
                        currency: selectedSubAccount.currencyCode,
                        token: selectedSubAccount.refreshToken,
                        emailId: selectedSubAccount.email,
                        accountId: selectedSubAccount.customerId,
                        accountName: selectedSubAccount.name,
                        masterAccountId: selectedSubAccount.masterId,
                        masterAccountName: selectedSubAccount.name,
                        timeZone: selectedSubAccount.timeZone
                    };
                    setAccountName(selectedSubAccount.name);
                    setAccountCurrency(selectedSubAccount.currencyCode);
                    dispatch(
                        thirdPartyAccountAction({
                            thirdPartyAccount: {
                                account: data
                            }
                        })
                    );
                }
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    const handleTouch = (e) => {
        const newTouched = { ...touched };
        const newErrors = { ...errors };
        const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
        newErrors[e.target.name] = error;
        newTouched[e.target.name] = true;
        setTouched(newTouched);
        setErrors(newErrors);
    };

    const getThirdPartyPartners = async (account) => {
        let thirdPartyPartners = [];
        let payload = {
            userInfoDetails: {
                advId: tenantId,
                clientPartner: [account]
            }
        };
        await dispatch(postThirdPartyLoginPartnersAction({ tenantId, authToken, userId, params: { platform: 'dv360' }, payload }))
            .then((data) => {
                const { responseCode: { msg, status = '' }, response } = data;
                if (status.toLowerCase() == "success" && response && response.length > 0) {
                    thirdPartyPartners = response;
                }
            }).catch((error) => {
                console.error(error);
            });
        return thirdPartyPartners;
    };

    const initialize = async () => {
        try {
            if (accounts && accounts.length == 1 && accounts.some(account => account.partner)) {
                const accountOptions = accounts.map(account => ({ key: account.id, value: `${account.id}` }));
                setOptions({
                    ...options,
                    accountOptions,
                });
                setForm({ ...form, [formFields.accountId.key]: accountOptions[0].key });
                setIsAccountChanged(!isAccountChanged);
            } else if (accounts && accounts.length > 1) {
                const accountOptions = accounts.map(account => ({ key: account.id, value: `${account.id}` }));
                setOptions({
                    ...options,
                    accountOptions,
                });
            } else {
                throw new Error('else case handle!');
            }
        } catch (e) {
            console.log(e);
        }
    };

    const resetErrorAndTouchedInKey = (key) => {
        const newErrors = { ...errors };
        const newTouched = { ...touched };
        delete newErrors[key];
        delete newTouched[key];
        setErrors(newErrors);
        setTouched(newTouched);
    };

    useEffect(() => {
        initialize();
    }, []);

    useEffect(() => {
        try {
            const fetchData = async () => {
                if (form[formFields.accountId.key]) {
                    const selectedAccount = accounts.find(account => account.id == form[formFields.accountId.key]);
                    if (selectedAccount) {
                        let subAccountData = await getThirdPartyPartners(selectedAccount);
                        subAccountData = subAccountData.map(item => ({ ...item, key: item.customerId, value: `${item.customerId}` }));
                        if (subAccountData && subAccountData.length == 1) {
                            setOptions({
                                ...options,
                                subAccountOptions: [{ key: subAccountData[0].customerId, value: `${subAccountData[0].customerId}` }],
                            });
                            setForm({ ...form, [formFields.subAccountId.key]: subAccountData[0].customerId });
                            setAccountName(subAccountData[0].name);
                            setAccountCurrency(subAccountData[0].currencyCode);
                            let data = {
                                currency: subAccountData[0].currencyCode,
                                token: subAccountData[0].refreshToken,
                                emailId: subAccountData[0].email,
                                accountId: subAccountData[0].customerId,
                                accountName: subAccountData[0].name,
                                masterAccountId: selectedAccount.id,
                                masterAccountName: selectedAccount.name,
                                timeZone: selectedAccount.timeZone
                            };
                            dispatch(
                                thirdPartyAccountAction({
                                    thirdPartyAccount: {
                                        account: data
                                    }
                                })
                            );
                        } else {
                            setOptions({ ...options, subAccountOptions: subAccountData });
                            setForm({
                                ...form,
                                [formFields.subAccountId.key]: ''
                            });
                            setAccountName('');
                            setAccountCurrency('');
                            dispatch(
                                thirdPartyAccountAction({
                                    thirdPartyAccount: {}
                                })
                            );
                        }
                    }
                }
            }
            fetchData();
            resetErrorAndTouchedInKey(formFields.subAccountId.key);
        } catch (error) {
            console.log(error);
        }
    }, [isAccountChanged]);

    return (
        <div className="row m-0 pt-3 pb-1">
            {
                isDisplayAccountName ?
                    <div style={{ flex: `0 0 20%` }}>
                        {children}
                    </div>
                    :
                    null
            }
            <div style={{ flex: `0 0 ${cardsWidth}` }}>
                <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary text-center">
                    <SelectNew
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[formFields.accountId.key]}
                        setting={formFields[formFields.accountId.key]}
                        error={errors[formFields.accountId.key]}
                        submited={false}
                        touched={touched[formFields.accountId.key]}
                        options={options.accountOptions}
                        disabled={(accounts && accounts.length == 1) ? true : false}
                    />
                </div>
            </div>
            <div style={{ flex: `0 0 ${cardsWidth}` }}>
                <SelectNew
                    onChange={handleChange}
                    onBlur={handleTouch}
                    value={form[formFields.subAccountId.key]}
                    setting={formFields[formFields.subAccountId.key]}
                    error={errors[formFields.subAccountId.key]}
                    submited={false}
                    touched={touched[formFields.subAccountId.key]}
                    options={options.subAccountOptions}
                    disabled={(options.subAccountOptions && options.subAccountOptions.length == 1) ? true : false}
                />
            </div>
            <div style={{ flex: `0 0 ${cardsWidth}` }}>
                <div className="form-group row">
                    <label class="col-sm-8 col-form-label">Account Name</label>
                    <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary my-2">{accountName}</div>
                </div>
            </div>
            <div style={{ flex: `0 0 ${cardsWidth}` }}>
                <div className="form-group row">
                    <label class="col-sm-8 col-form-label">Account Currency</label>
                    <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary my-2">{accountCurrency}</div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(DV360Account);